import { onUserSnap } from "@utils/onUserSnap";
export const updateUserWhenCreate = (user, payload) => {
  const userRef = window.db.collection("Users");
  onUserSnap(userRef, user, payload);
};
